// extracted by mini-css-extract-plugin
export var divider = "_r3-0";
export var systemMessage = "_r3-1";